import { createContext, useContext, useEffect, useState } from "react";
import { DISPLAY_LANG } from "../config";
import { CurrencyContext } from "./CurrencyContext";
import axios from "../axios";

export const CartContext = createContext();

export default function CartProvider({ children }) {
    const [orders, setOrders] = useState([]);
    const [cartTotalAmount, setCartTotalAmount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [cursorLoad, setCursorLoad] = useState(false);

    const { selectedCurrency } = useContext(CurrencyContext);

    const ceil = (value) => Math.ceil(value) || 0;

    useEffect(() => {
        loadingOrders();
    }, []);

    useEffect(() => {
        // console.log('============== orders ==============');
        // console.log(orders);

        const total = orders.reduce((acc, item) => {
            if (item.item_type === 'domain') {
                return acc + ceil(item.domain_price[selectedCurrency.title]);
            } 
            
            if (item.item_type === 'hosting') {
                const hostingPrice = item.isp_hosting_price[item.isp_hosting_billing_type];
                return acc + ceil(hostingPrice[selectedCurrency.title]);
            }

            return acc;
        }, 0);

        setCartTotalAmount(total.toFixed(2));
    }, [orders]);

    const loadingOrders = async () => {
        const userId = localStorage.getItem('user_id');

        if (userId) {
            await axios.get(`users/cart/${userId}`)
                .then(res => {
                    setOrders(res.data.items);

                    /*  մուքում եկած դատան, սորտավորում եմ created_at ի հակառակ հերթականությամբ  */
                    const sortedItems = res.data.items.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
                    setOrders(sortedItems);

                    setLoading(false);
                })
                .catch(err => console.log(err));
        }
    };

    const removeFromCart = async (id) => {
        try {
            setCursorLoad(true);

            const res = await axios.delete(`users/cart/delete_item/${id}`);

            if (!res.data.ok) {
                throw new Error('An error occurred');
            }

            const newOrders = orders.filter(elem => elem.id !== id);
            setOrders(newOrders);
            setCursorLoad(false);
        } catch (error) {
            setCursorLoad(false);
            console.log(error);
            throw error;
        }
    };


    /*  ================= domain ================= */

    const addDomainToCart = async (item) => {
        setCursorLoad(true);

        const userId = localStorage.getItem('user_id');

        const body = {
            cart: userId,
            item_type: 'domain',
            domain: item.domain,
            domain_status: item.status,
            domain_classKey: item.classKey,
            domain_price: item.domain_yearly_price,
            domain_number_of_years: "1",
            domain_connected_hosting_name: item.plan,
            domain_connected_hosting_billing_type: item.billing_type,
        };

        try {
            const existingDomain = orders.find(el => el.domain === item.domain);

            if (existingDomain) {
                await removeFromCart(existingDomain.id);
            } else {
                const res = await axios.post('users/cart/add', body);

                /*  մուքում եկած դատան, սորտավորում եմ created_at ի հակառակ հերթականությամբ  */
                const sortedItems = res.data.orders.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
                setOrders(sortedItems);
            }

            setCursorLoad(false)
        } catch (error) {
            setCursorLoad(false)
            throw error;
        }
    };

    const changeYearFromDomain = async (id, value, domain_classKey) => {
        try {
            setCursorLoad(true);

            const res = await axios.patch(`users/cart/patch/${id}`, {
                domain_number_of_years: value,
                domain_classKey
            });

            if (!res.data.ok) {
                throw new Error('An error occurred');
            }

            /*  մուքում եկած դատան, սորտավորում եմ created_at ի հակառակ հերթականությամբ  */
            const sortedItems = res.data.items.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
            setOrders(sortedItems);

            setCursorLoad(false);
        } catch (error) {
            console.log(error);
            setCursorLoad(false);
            throw error;
        }
    };


    /*  ================= hosting ================= */

    const addHostingToCart = async (body) => {
        const res = await axios.post('users/cart/add', body);

        if (!res.data.ok) {
            throw new Error('Error in add hosting to cart')
        }

        setOrders(res.data.orders);
    };


    const updateHosintgBillingTpye = async (id, value) => {
        try {
            setCursorLoad(true);

            const res = await axios.patch(`users/cart/patch/${id}`, {
                isp_hosting_billing_type: value,
            });

            if (!res.data.ok) {
                throw new Error('An error occurred');
            }

            setOrders(res.data.items);
            setCursorLoad(false);
        } catch (error) {
            console.log(error);
            setCursorLoad(false);
            throw error;
        }
    }


    /* ================ pay cart api ================ */

    const goToPaymentMethodPage = async () => {
        setCursorLoad(true);
        const existingDomain = orders.some(elem => elem.item_type === "domain");

        if (existingDomain) {
            return '/user/domain-register-details';
        }

        setCursorLoad(false);
        return '/user/payment-method';
    };

    return (
        <CartContext.Provider value={{
            orders, setOrders, loading, cursorLoad, cartTotalAmount, addDomainToCart,
            removeFromCart, changeYearFromDomain, addHostingToCart, goToPaymentMethodPage,
            updateHosintgBillingTpye, loadingOrders, setCursorLoad,
        }}>
            {children}
        </CartContext.Provider>
    );
}